// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ArticleVO } from '@article/model/vo/article.vo';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleExportManager } from '../../../manager/article-export.manager';

/**
 * Component to save an article as new version or to override an existing article
 */
@Component({
  standalone: false,
  selector: 'app-article-version',
  templateUrl: './article-version.component.html',
  styleUrls: ['./article-version.component.scss']
})
export class ArticleVersionComponent {

  @Input()
  public articleVO: ArticleVO;
  @Output()
  public finish = new EventEmitter<boolean>();

  constructor(private bsModalRef: BsModalRef, private articleExportManager: ArticleExportManager) {}

  public override(): void {
    this.saveArticle();
  }

  public saveAsNewVersion(): void {
    this.articleVO.version++;
    this.saveArticle();
  }

  public close(result: boolean = false): void {
    this.finish.emit(result);
    this.bsModalRef.hide();
  }

  private saveArticle(): void {
    if (!this.articleVO) {
      return;
    }
    this.articleExportManager.saveArticle(this.articleVO).subscribe(() => {
      this.close(true);
    });
  }
}
